
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { commonModule, companyModule, installationsModule } from '@/store/modules/store-accessor'
import { TimeUtil } from '@/helpers/TimeUtil'
import dayjs from "dayjs";
import {
  appointmentStatusToColor,
  appointmentStatusToName,
  calcDuration,
  formatAmount,
  formatDateWithoutSeconds,
  formatOnlyDate,
  taskColor,
  templatesFilenameLanguage,
  getOptimalTextColor,
  taskStatusToName,
  taskStatusToColor
} from "@/helpers/data";
import FileSaver from "file-saver";
import InstallationItemWarrantyIndicator from "@/components/InstallationItemWarrantyIndicator.vue";

@Component({
  components: { InstallationItemWarrantyIndicator },
})
export default class InstallationsItems extends Vue {
  @Prop() itemsExist!: boolean;
  @Prop() itemsList!: any[];
  @Prop() installation!: any;
  @Prop() item!: any;
  @Prop() subHeaderMsg!: string;
  @Prop() emptyMessage!: string;

  isDownloadingItemPdf = false;

  tableOptions = { sortBy: ['is_primary', 'is_active'], sortDesc: [true, true] }

  tableheaders: any [] = [
    { class:'font-weight-black', text: this.$t("type"), sortable: false, value: 'type_name'},
    { class:'font-weight-black', text: this.$t("make"), sortable: false, value: 'make' },
    { class:'font-weight-black', text: this.$t("model"), sortable: false, value: 'model' },
    { class:'font-weight-black', text: this.$t("serial_number"), sortable: false, value: 'serial_no' },
    { class:'font-weight-black', text: this.$t("is_active"), sortable: false, value: 'is_active' },
    { class:'font-weight-black', text: this.$t("primaryItem"), value: 'is_primary', width: '85px', sortable: false },
    { text: '', value: 'data-table-expand' },
  ]

  mounted() {
    if ((companyModule.company?.preferences as any)?.installation_item_description) {
      this.tableheaders.splice(0, 0, {
        text: this.$t('description'),
        sortable: true,
        class: 'row-style',
        value: 'description',
      });
    }
  }

  model: Record<string, any> = { search: '' }

  formatDate (date: Date): string { return TimeUtil.formatDate(date) }
  formatDateTime (date: Date): string { return TimeUtil.formatDateTime(date) }

  addInstallationItem(){
    commonModule.showModal({ name: 'add-installation-item-modal', payload: { installation: this.installation }})
  }

  editInstallationItem (item: any){
    commonModule.showModal({ name: 'edit-installation-item-modal', payload: { installation_item: item, installation: this.installation }})
  }

  deleteInstallationItem (item: any){
    commonModule.showModal({ name: 'delete-installation-item-modal', payload: { installation_item: item, installation: this.installation }})
  }

  async donwloadItemPdf(item: Record<string, unknown>) {
    this.isDownloadingItemPdf = true;
    const userTimezone = dayjs.tz.guess();
    const data = {
      installationId: item.installation_id,
      itemId: item.id,
      user_timezone: userTimezone,
      language: localStorage.getItem('lang'),
    };

    try {
      if (data.installationId && data.itemId) {
        const company = await companyModule.getCompanyInfo();
        const filename = `${templatesFilenameLanguage()}_${(company as any).entity_name}_${this.installation.info.tag_id}_item_${data.itemId}.pdf`.replace(/ /g, '_');
        const pdf = await installationsModule.getInstallationItemPdfExportAction(data);
        const file = new File([pdf], filename);
        FileSaver.saveAs(file);
      }
    } finally {
      this.isDownloadingItemPdf = false;
    }
  }

  formatBalance(balance: number) { return formatAmount(balance); }
  setJobActions(actions: string[]) { return actions && actions.length > 0 ? actions.join(', ') : '-'; }

  statusToColor(status: string){ return appointmentStatusToColor(status) }
  statusToName(status: string) { return appointmentStatusToName(status) }

  appointmentIsComplete(appointment: any) { return appointment.appointment_status_id == 4 }
  setDuration(start: Date, end: Date) { return calcDuration(start, end); }

  getFormattedAppointmentDuration(appointment: any) {
    if (appointment.appointment_status_id == 4) {
      return (appointment.actual_start && appointment.actual_end) ? this.setDuration(appointment.actual_start, appointment.actual_end) : '-';
    } else {
      return (appointment.scheduled_start && appointment.scheduled_end) ? this.setDuration(appointment.scheduled_start, appointment.scheduled_end) : '-';
    }
  }

  dateToColor(task: Record<string, any>) { return taskColor(task); }

  formatTaskDate(date: Date, all_day: string) {
    if (!date) return "-";
    return all_day ? formatOnlyDate(date) : formatDateWithoutSeconds(date);
  }

  showReminderLabel(task: Record<string, any>) {
    return task.title && task.title.length > 0
      ? task.title
      : task.category && task.category.includes(1)
      ? this.$i18n.t("reminder_label")
      : "-";
  }

  optimalTextColor(color: string) { return getOptimalTextColor(color); }

  get jobDescriptionIsEnabled() { return (companyModule.company?.preferences as any)?.job_description; }

  get tableIsLoading() {
    return installationsModule.sideviewTableIsLoading;
  }

  setActionsText(job: Record<string, any>) {
    if (this.jobDescriptionIsEnabled && job.description?.length > 0) return job.description;
    return this.setJobActions(job.action_type_names)
  }

  taskStatusToName(status: any) { return taskStatusToName(status); }
  taskStatusToColor(status: number) { return taskStatusToColor(status) }
}
